export const COPY = {
  title: 'Download and sync Authy',
  enterTheCode: 'Or enter the code:',
  button: 'Finish and login'
}
